import React from "react";
import FormDialog from "helpers/FormDialog";
import DeleteDialog from "helpers/DeleteDialog";
import StructureHierachy from "helpers/StructureHierachy";

const Structure = ({
  structures,
  onSuccess,
  setSelect,
  setSelectedStructure,
  loggedUser,
  setSelectedType,
  setOpen,
  open,
  setOpenSetting
}) => {
  const [value, setValue] = React.useState({});
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [deleteUrl, setDeleteActionUrl] = React.useState(null);
  const [parent, setParent] = React.useState();

  const handleDelete = (id) => {
    setDeleteOpen(1);
    setDeleteActionUrl(`/api/structure/${id}`);
  };

  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={async () => {
          await onSuccess();
        }}
        url={deleteUrl}
      />

      <FormDialog
        maxWidth={"md"}
        col={6}
        open={open > 0}
        onSuccess={async () => {
          await onSuccess();
        }}
        setOpen={setOpen}
        url={
          open === 1
            ? "/api/structure/create"
            : `/api/structure/update/${value["id"]}`
        }
        title={open === 1 ? "Create New Structure" : "Edit Structure"}
        fields={[
          {
            name: "name",
            label: "Name",
            value: value["name"] || "",
            required: true,
            col: 12,
            setValue: (val) => setValue0("name", val),
          },
          {
            name: "category",
            label: "category",
            value: value["category"],
            col: 12,
            setValue: (val) => setValue0("category", val),
          },
          {
            name: "parent",
            label: "Parent",
            value: parent?.name,
            disabled: true,
            hidden: !parent,
            col: 12,
          },
          {
            name: "parentId",
            label: "Parent",
            value: parent?.id,
            hidden: true,
            col: 12,
          },
        ]}
      />
      <StructureHierachy
        structures={structures}
        setValue0={setValue0}
        setParent={setParent}
        setOpen={setOpen}
        loggedUser={loggedUser}
        handleDelete={handleDelete}
        setSelectedStructure={setSelectedStructure}
        setOpenAddMenu={setSelect}
        setSelectedType={setSelectedType}
        setOpenSetting={setOpenSetting}
      />
    </div>
  );
};
export default Structure;
